import React from "react";
import Div from "../../../widget/common/ui/Div";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { Col, Row } from "react-bootstrap";
import { SearchContextImport } from "../../../provider/search/SearchContextProvider";
import { Listing, ListItem } from "../../../widget/common/ui/Listing";
import { TextBlock } from "../../../widget/common/ui/Text";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { textCase } from "../../../service/ui/UI";
import { SearchBranchList } from "../../../model/search/SearchBranchListModel";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import NoData from "../../../widget/common/ui/NoData";
import TeamListItem from "../../../widget/screens/team_list/TeamListItem";
import BranchListDivisionSwitch from "../../branch/branch_list/widget/BranchListDivisionSwitch";

export const SearchTab = (props: { type?: number | undefined }) => {
  const { tabId, handleChangeTab } = SearchContextImport();

  return (
    <Div>
      <Row className="text-center theme-tab px-3">
        <Col
          role="button"
          className={`${tabId === "1" ? "active" : ""} pt-0 pt-lg-3`}
          onClick={() => handleChangeTab("1")}
        >
          {AppTranslation.text("branch")}
        </Col>
        <Col
          role="button"
          className={`${tabId === "2" ? "active" : ""} pt-0 pt-lg-3`}
          onClick={() => handleChangeTab("2")}
        >
          {AppTranslation.text("profile")}
        </Col>
      </Row>
    </Div>
  );
};

export const SearchProfileListing = () => {
  const { profileList, onClickTeam } = SearchContextImport();
  return (
    <>
      {profileList === false ? (
        <Div>
          <NoData />
        </Div>
      ) : (
        <>
          {profileList == null ? (
            <Center className="pt-5 mt-5">{Loader.normal()}</Center>
          ) : (
            <Listing>
              {(profileList ?? []).map((profile, key) => (
                <ListItem key={key}>
                  <div role="button" onClick={() => onClickTeam(profile)}>
                    <TeamListItem
                      name={profile?.name!}
                      title={profile?.title!}
                      logo={profile?.logo_url!}
                      subTitle={profile?.branch_name!}
                    />
                  </div>
                </ListItem>
              ))}
            </Listing>
          )}
        </>
      )}
    </>
  );
};

export const SearchBranchListing = () => {
  const {
    branchList,
    searchValue,
    onClickBranch,
    divisionTitle,
    switchDivision,
    companyGroupType,
  } = SearchContextImport();

  return (
    <>
      {branchList === false ? (
        <Div>
          <NoData />
        </Div>
      ) : branchList == null ? (
        <Center className="pt-5 mt-5">{Loader.normal()}</Center>
      ) : (
        <>
        
          {companyGroupType === "1" &&
            UtilityHelper.isNotEmpty(divisionTitle) && (
              <BranchListDivisionSwitch
                title={divisionTitle}
                switchDivision={switchDivision}
              />
            )}

          <Listing>
            {(branchList ?? []).map((branch, key) => (
              <ListItem key={key}>
                <div role="button" onClick={() => onClickBranch(branch)}>
                  <Div fontName="book" color="theme-sublabel" fontSize="13_14">
                    <TextBlock
                      fontName="bold"
                      textColor="theme-label"
                      fontSize="16_17"
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: UtilityHelper.wrapKeyword(
                            branch?.title!,
                            searchValue
                          ),
                        }}
                      />
                    </TextBlock>
                    <TextBlock
                      fontName="book"
                      textColor="theme-sublabel"
                      fontSize="13_14"
                    >
                      {textCase(branch.description!)}
                    </TextBlock>

                    {areaCityText(branch)}
                    {stateCityText(branch)}
                  </Div>
                </div>
              </ListItem>
            ))}
          </Listing>
        </>
      )}
    </>
  );
};

const areaCityText = (detail: SearchBranchList) => {
  let areaCityNameArr: Array<string> = [detail.area_name!, detail.city_name!];
  areaCityNameArr = areaCityNameArr.filter((item) =>
    UtilityHelper.isNotEmpty(item)
  );

  return (
    <>
      {areaCityNameArr.length > 0 && (
        <TextBlock fontName="book" textColor="theme-sublabel" fontSize="13_14">
          {textCase(areaCityNameArr.join(" / "))}
        </TextBlock>
      )}
    </>
  );
};

const stateCityText = (detail: SearchBranchList) => {
  let stateCountryNameArr: Array<string> = [
    detail.state_name!,
    detail.country_name!,
  ];
  stateCountryNameArr = stateCountryNameArr.filter((item) =>
    UtilityHelper.isNotEmpty(item)
  );

  return (
    <>
      {stateCountryNameArr.length > 0 && (
        <TextBlock fontName="book" textColor="theme-sublabel" fontSize="13_14">
          {textCase(stateCountryNameArr.join(" / "))}
        </TextBlock>
      )}
    </>
  );
};
